export const SEED_LIST_TITLE_ID = 'seeds-list-title';
export const SEED_LIST_DESCRIPTION_ID = 'seeds-list-description';
export const SEED_INPUT_WIDTH = '257px';
